module.exports = __webpack_public_path__ + "static/media/incomeArrow.87c4afcf.svg";